import { ReactNode } from 'react';

import { GenericDataSet, ScaleConfig, SeriesConfig } from './types';
import { formatValueForPlottingWithSeriesConfig, getMergedSeriesConfigForField } from './utilities/utils';

export const getFormattedDataColumns = (
    data: GenericDataSet,
    seriesConfig?: SeriesConfig,
    scaleConfig?: ScaleConfig
): ReactNode[][] => {
    const { fields, columns: originalColumns } = data;

    const [, ...dataColumns] = originalColumns;

    let fieldsIndex = 1;

    const formattedDataColumns = dataColumns.map(dataColumn => {
        const mergedSeriesConfig = getMergedSeriesConfigForField(
            fields[fieldsIndex],
            seriesConfig,
            scaleConfig
        );

        if (mergedSeriesConfig.scale !== 'y') {
            return dataColumn;
        }
        const formattedDataColumn = dataColumn.map(dataPoint => {
            if (dataPoint === null || Number.isNaN(dataPoint)) {
                return mergedSeriesConfig?.replaceNullsWithZero === true ? 0 : null;
            }
            return formatValueForPlottingWithSeriesConfig(dataPoint, mergedSeriesConfig, data);
        });
        fieldsIndex += 1;

        return formattedDataColumn;
    });
    return formattedDataColumns;
};
